import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import {
  HeaderSection,
  MainSection,
  SubHeaderSection,
  QuizHeader,
} from '@skooldio/skooldio-classroom-components';

import { useConfig } from 'Context/ConfigContext';
import QuizWrapper from 'Components/Quiz/Components/QuizWrapper';

import { Box, Flex, SvgIcon, Text } from '../../../../Base';
import { RESULT_TYPE } from '../constant';
import { QUIZ_VARIANTS } from '../../../constant';

const getHeaderText = (variant) => {
  switch (variant) {
    case QUIZ_VARIANTS.OFFICIAL_EXAM:
      return 'เฉลยข้อสอบ';
    default:
      return 'เฉลยแบบฝึกหัด';
  }
};

const getResultType = (result) => {
  switch (result) {
    case RESULT_TYPE.INCORRECT:
      return {
        icon: SvgIcon.ICON_LIST.CLOSE_CIRCLE,
        color: 'danger',
        text: 'ผิด',
      };
    case RESULT_TYPE.CORRECT:
    default:
      return {
        icon: SvgIcon.ICON_LIST.CHECK_CIRCLE,
        color: 'success',
        text: 'ถูก',
      };
  }
};

const SolutionList = ({
  variant,
  onBack,
  round,
  score,
  fullScore,
  results,
  isShowScore,
  onSeeDetailSolution,
}) => {
  const {
    classroom: { quiz = {} },
  } = useConfig();
  const { bgColor = 'primary' } = quiz;
  const { colors } = useTheme();
  return (
    <QuizWrapper subHeader>
      <HeaderSection>
        <QuizHeader
          title={getHeaderText(variant)}
          onBack={onBack}
          outerWrapperProps={{ bg: colors[bgColor] }}
        />
      </HeaderSection>
      <SubHeaderSection>
        <Flex justifyContent={'center'} py={5} px={6} bg={'greyscale.grey5'} width={'100%'}>
          <Flex width={'100%'} maxWidth={1164} justifyContent={'space-between'} px={6}>
            <Text textStyle={'subtitle1'}>{`รอบที่ ${round}`}</Text>
            <Text textStyle={'subtitle1'}> {`คะแนน ${score}/${fullScore}`}</Text>
          </Flex>
        </Flex>
      </SubHeaderSection>
      <MainSection>
        <Box>
          {results.map((q) => {
            const { index, result, id, score } = q;
            const resultType = getResultType(result);
            return (
              <Box
                key={id}
                py={5}
                px={6}
                width={'100%'}
                onClick={() => onSeeDetailSolution(id)}
                style={{ borderBottom: '1px solid #e5e5e5' }}
              >
                <Flex
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  width={'100%'}
                  maxWidth={1164}
                  mx={'auto'}
                  px={6}
                >
                  <Text>ข้อ {index + 1} </Text>
                  <Flex ml={'auto'} alignItems={'center'}>
                    <SvgIcon icon={resultType.icon} size={24} color={resultType.color} mr={2} />
                    <Text>{resultType.text}</Text>
                    {isShowScore && (
                      <Text ml={{ _: 3, md: 7 }} textStyle={'body1Medium'} color={resultType.color}>
                        {score.toFixed(2)} คะแนน
                      </Text>
                    )}
                  </Flex>
                  <SvgIcon
                    icon={SvgIcon.ICON_LIST.ARROW_RIGHT}
                    size={24}
                    ml={{ _: 1, md: 3 }}
                    color={'text'}
                  />
                </Flex>
              </Box>
            );
          })}
        </Box>
      </MainSection>
    </QuizWrapper>
  );
};

SolutionList.propTypes = {
  onBack: PropTypes.func,
  round: PropTypes.string,
  result: PropTypes.string,
  question: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      result: PropTypes.oneOf(Object.values(RESULT_TYPE)),
      id: PropTypes.string,
    })
  ),
  onSeeDetailSolution: PropTypes.func,
};

SolutionList.defaultProps = {
  questions: [],
};

export { RESULT_TYPE };
export default SolutionList;
